import React from 'react';

// Types
import { Attachment, AttachmentFilesTypes } from 'Shared/types/Attachment.type';

// Utils
import * as AttachmentUtils from 'Shared/utils/Attachment.utils';

// Components
import WpIcon from 'Wpds/components/icon/WpIcon';

// Styles
import './AttachmentTypeIcon.scss';

type Props = {
  attachment: Attachment;
};

const AttachmentTypeIcon = ({ attachment }: Props) => {
  const fileType = AttachmentUtils.getFileType({ attachment });

  const getIconName = () => {
    switch (fileType) {
      case AttachmentFilesTypes.IMAGE:
        return 'image';
      case AttachmentFilesTypes.VIDEO:
        return 'play-circle';
      case AttachmentFilesTypes.MSWORD:
        return 'file-word';
      case AttachmentFilesTypes.MSEXCEL:
        return 'file-excel';
      case AttachmentFilesTypes.MSPPT:
        return 'file-powerpoint';
      case AttachmentFilesTypes.CSV:
        return 'file-spreadsheet';
      case AttachmentFilesTypes.PDF:
        return 'file-pdf';
      case AttachmentFilesTypes.AUDIO:
        return 'music';
      case AttachmentFilesTypes.ARCHIVE:
        return 'file-archive';
      default:
        return 'paperclip';
    }
  };

  return (
    <div className="AttachmentTypeIcon">
      <WpIcon name={getIconName()} />
    </div>
  );
};

export default AttachmentTypeIcon;
